import type { VChartSpecPipeline } from 'src/types'
import {
  initBar,
  backgroundColor,
  label,
  tooltip,
  discreteLegend,
  color,
  barStyle,
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
  horizontalCrosshairRect,
  barCornerRadius,
  progressive,
  colorAdapter,
  linearColor,
  colorLegend,
  colorBarStyleFill,
  barMaxWidth,
  brush,
  playerBar,
  xLinear,
  yBand,
  datasetYX,
  isPlayer,
  fontFamilyTheme,
} from '../pipes'

const raceBar: VChartSpecPipeline = [
  fontFamilyTheme,
  initBar,
  barCornerRadius,
  barMaxWidth,
  colorAdapter(color, linearColor),
  backgroundColor,
  isPlayer(playerBar, datasetYX),
  progressive,
  xLinear,
  yBand,

  label,
  brush,
  tooltip({ titleEncoding: 'y' }),
  colorAdapter(discreteLegend, colorLegend),
  horizontalCrosshairRect,
  colorBarStyleFill(barStyle),
  annotationPoint,
  annotationVerticalLine,
  annotationHorizontalLine,
  annotationAreaBand,
]

export const raceBarSpecPipeline = raceBar
